import { render, staticRenderFns } from "./imgs.vue?vue&type=template&id=106dbe26&scoped=true"
import script from "./imgs.vue?vue&type=script&lang=js"
export * from "./imgs.vue?vue&type=script&lang=js"
import style0 from "./imgs.vue?vue&type=style&index=0&id=106dbe26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106dbe26",
  null
  
)

export default component.exports